/* =========================================================
   Ankit START - BXGY Deal Buttons (ORIGINAL WORKING BASE)
   ========================================================= */
(function () {
  function toInt(v){
    var n = parseInt(v,10);
    return Number.isFinite(n) ? n : 0;
  }

  function findRow(el){
  return (
    el.closest('.cart-item') ||          // ← CART ROW (THIS WAS MISSING)
    el.closest('[data-item-row]') ||     // ← YOUR CART USES THIS
    el.closest('.dfw-reorder-row') ||
    el.closest('.options-items') ||
    el.closest('.product-item') ||
    el.closest('[data-product-id]') ||
    el.closest('form')
  );
}


  document.addEventListener('click', function (e) {
    var dealBtn = e.target.closest('[data-bxgy-btn]');
    if (!dealBtn) return;

    var row = findRow(dealBtn);
    if (!row) return;

    var dealQty = toInt(dealBtn.getAttribute('data-deal-qty'));
    if (!dealQty) return;

    var qtyInput = row.querySelector('input[name="quantity"]');
    var addBtn   = row.querySelector('[data-express-addToCart]');
    if (!qtyInput) return;


    if (dealBtn.dataset.loading === '1') return;
    dealBtn.dataset.loading = '1';
    dealBtn.disabled = true;

    var originalQty = qtyInput.value;

    qtyInput.value = String(dealQty);
    if (addBtn) {
  // Express / product / reorder
  addBtn.click();
} else {
  // Cart page
  qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
  qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
}

    setTimeout(function () {
      qtyInput.value = originalQty;
      dealBtn.disabled = false;
      dealBtn.dataset.loading = '0';
    }, 0);
  }, false);
})();
 /* =========================================================
    Ankit END - BXGY Deal Buttons (ORIGINAL WORKING BASE)
    ========================================================= */

    /* =========================================================
   Ankit START - BXGY Drawer Rebind Extension
   Only fixes Halo sidebar refresh issue
   ========================================================= */

(function(){

  function rebindDrawer(){

    var drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer) return;

    drawer.querySelectorAll('[data-bxgy-btn]').forEach(function(btn){
      btn.dataset.loading = '0';
      btn.disabled = false;
    });

  }

  // After sidebar refresh
  document.addEventListener('cart:refresh', function(){
    setTimeout(rebindDrawer, 150);
  });

  // After quantity update inside drawer
  document.addEventListener('change', function(e){
    if (e.target.closest('#halo-cart-sidebar')){
      setTimeout(rebindDrawer, 150);
    }
  });

})();


/* =========================================================
   Ankit START - DFW BXGY (Cart Page + Cart Drawer Summary)
   - Calculates free cases + free value
   - Highlights applied tier in green
   - Survives AJAX cart re-render (MutationObserver)
   ========================================================= */
(function () {
  function centsToMoney(cents) {
    // Uses Shopify's money format if available, fallback to USD formatting
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : "USD",
    }).format((cents || 0) / 100);
  }

  function getCartItemRows() {
    // Works for cart page; harmless elsewhere
    return Array.from(document.querySelectorAll("#main-cart-items .cart-item[data-item-row]"));
  }

  function readQtyFromRow(row) {
    const input = row.querySelector('input.cart-item-qty-input[name="quantity"]');
    const qty = parseInt(input && input.value ? input.value : "0", 10);
    return Number.isFinite(qty) ? qty : 0;
  }

  function readUnitPriceCentsFromRow(row) {
    // Your Liquid sets: data-price="{{ price_to_display }}" (cents)
    const priceEl = row.querySelector(".cart-item-total[data-price]");
    const cents = parseInt(priceEl && priceEl.getAttribute("data-price") ? priceEl.getAttribute("data-price") : "0", 10);
    return Number.isFinite(cents) ? cents : 0;
  }

  function readTiersFromRow(row) {
    // Your tiers exist in 2 places (note + buttons). We only need one set.
    // Prefer tiers with data-bxgy-get present (your "buttons" block).
    const tierEls = Array.from(row.querySelectorAll(".dfw-bxgy-tier[data-bxgy-buy][data-bxgy-get]"));

    const tiers = tierEls
      .map((el) => {
        const buy = parseInt(el.getAttribute("data-bxgy-buy"), 10);
        const get = parseInt(el.getAttribute("data-bxgy-get"), 10);
        if (!Number.isFinite(buy) || !Number.isFinite(get) || buy <= 0 || get <= 0) return null;
        return { buy, get, el };
      })
      .filter(Boolean)
      .sort((a, b) => a.buy - b.buy);

    return tiers;
  }

  function pickAppliedTier(qty, tiers) {
    // Choose the largest buy <= qty
    let applied = null;
    for (const t of tiers) {
      if (qty >= t.buy) applied = t;
    }
    return applied;
  }

  function clearAppliedStyles(row) {
    row.querySelectorAll(".dfw-bxgy-tier.dfw-bxgy-active").forEach((el) => {
      el.classList.remove("dfw-bxgy-active");
    });
    row.querySelectorAll(".dfw-cart-bxgy-note .dfw-bxgy-tier.dfw-bxgy-active").forEach((el) => {
      el.classList.remove("dfw-bxgy-active");
    });
  }

  function applyTierHighlight(row, appliedBuy) {
    if (!appliedBuy) return;

    // Highlight tiers in BOTH displays:
    // 1) your "buttons" tier spans
    row.querySelectorAll('.dfw-bxgy-tier[data-bxgy-buy]').forEach((el) => {
      const b = parseInt(el.getAttribute("data-bxgy-buy"), 10);
      if (b === appliedBuy) el.classList.add("dfw-bxgy-active");
    });

    // 2) your "note" tier spans (these have only data-bxgy-buy)
    row.querySelectorAll('.dfw-cart-bxgy-note .dfw-bxgy-tier[data-bxgy-buy]').forEach((el) => {
      const b = parseInt(el.getAttribute("data-bxgy-buy"), 10);
      if (b === appliedBuy) el.classList.add("dfw-bxgy-active");
    });
  }

  function updateBxgySummary() {
    const rows = getCartItemRows();
    if (!rows.length) return;

    let totalFreeCases = 0;
    let totalFreeValueCents = 0;

    rows.forEach((row) => {
      const qty = readQtyFromRow(row);
      const unitCents = readUnitPriceCentsFromRow(row);
      const tiers = readTiersFromRow(row);

      // Always clear first, then re-apply
      clearAppliedStyles(row);

      if (!tiers.length || qty <= 0) return;

      const applied = pickAppliedTier(qty, tiers);
      if (!applied) return;

      const multiplier = Math.floor(qty / applied.buy);
      const freeQty = multiplier * applied.get;

      totalFreeCases += freeQty;
      totalFreeValueCents += (freeQty * unitCents);

      applyTierHighlight(row, applied.buy);
    });

    const wrapper = document.getElementById("dfw-bxgy-summary-wrapper");
    const casesEl = document.getElementById("dfw-bxgy-free-cases");
    const valueEl = document.getElementById("dfw-bxgy-free-value");

    if (!wrapper || !casesEl || !valueEl) return;

    if (totalFreeCases > 0) {
      casesEl.textContent = `${totalFreeCases} Free Cases Added`;
      valueEl.textContent = `${centsToMoney(totalFreeValueCents)} Total Free Value`;
      wrapper.style.display = ""; // unhide
    } else {
      wrapper.style.display = "none";
    }
  }

  // Debounce for rapid +/- clicking
  let t = null;
  function queueUpdate() {
    window.clearTimeout(t);
    t = window.setTimeout(updateBxgySummary, 80);
  }

  function bindListeners() {
    // Qty input changes
    document.addEventListener("change", function (e) {
      if (e.target && e.target.matches && e.target.matches("#main-cart-items input.cart-item-qty-input[name='quantity']")) {
        queueUpdate();
      }
    });

    // +/- clicks (Ella often updates input value + triggers ajax)
    document.addEventListener("click", function (e) {
      const btn = e.target && e.target.closest ? e.target.closest("[data-plus-quantity-cart], [data-minus-quantity-cart]") : null;
      if (btn) queueUpdate();
    });

    // Observe cart rerenders (AJAX)
    const cartRoot = document.getElementById("main-cart-items");
    if (!cartRoot) return;

    const obs = new MutationObserver(function () {
      queueUpdate();
    });

    obs.observe(cartRoot, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
      if (window.DFWBXGY) return;
    bindListeners();
    updateBxgySummary();
  });
})();
/* =========================================================
   Ankit END - DFW BXGY (Cart Page + Cart Drawer Summary)
   ========================================================= */
